import { object, string } from 'yup';

export const requestProductionRegionValidationSchema = object({
  name: string().required('Required'),
  origin: string().required('Required')
});